import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import ApiService from './api';
import DS from 'ember-data';

export enum OtherExportType {
  DuplicatedAttribute = 'duplicated_attribute',
  AllDevices = 'devices',
}

export default class CustomerService extends Service {
  @service api!: ApiService;
  @service store!: DS.Store;

  exports({
    email,
    filters,
    attributes,
    from,
    includeRelationships = false,
  }: {
    email?: string | null;
    filters: string | null;
    attributes: string[] | null;
    from: string;
    includeRelationships?: boolean;
  }) {
    return this.get('api').post('customers/exports', {
      data: { email, filters, attributes, exported_from: from, export_relationships: includeRelationships },
    });
  }

  exportOther({ exportType, attributes, duplicatedAttribute }: Record<string, any>) {
    let data: any = { attributes };
    if (exportType === OtherExportType.DuplicatedAttribute) {
      data.attribute = duplicatedAttribute;
    }

    return this.get('api').post(`exports/${exportType}`, { data });
  }

  fetchRecipientCount = task({ restartable: true }, async (filters: string | null | undefined) => {
    let customers = this.store.query('customer', { filters });
    let response = await customers;
    return (response as any).meta.pagination.total;
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    customer: CustomerService;
  }
}
